const EduCard = () => {
  return ( <div className=""></div> );
}
 
export default EduCard;